<template>
  <div class="container-xxl">
    <titulo-grande texto="Relatório financeiro" posicao="left" />

    <div class="alert alert-secondary" role="alert">
      <div class="row align-items-center">
        <InputText classDiv="col-sm-6 col-md-3" tipo="date" nome="data_ini" label="Data Inicial"
          v-model="dados.data_ini" />
        <InputText classDiv="col-sm-6 col-md-3" tipo="date" nome="data_fim" label="Data Inicial"
          v-model="dados.data_fim" />

        <InputSelect placeholder="" label="Tipo de relatório *" :dados="dados_tipo_relatorio" tamanho="sm"
          classDiv="col-sm-6 col-md-3" name="tipo_relatorio" ref="dados.tipo_relatorio"
          v-model="dados.tipo_relatorio" />

        <div class="col-sm-6 col-md-3 d-grid gap-2">
          <button class="btn btn-info btn-lg text-white mb-3" @click="carrega_relatorio()">Carregar Relatório</button>
        </div>
      </div>
    </div>

    <div class="alert alert-secondary" role="alert">
      <b>Entre as datas:</b> {{ dadosData.filtro.periodo }}
    </div>

    <div class="row">
      <div class="col-sm-6" v-if="dadosData.total_receitas">
        <div class="card text-bg-success mb-3">
          <div class="card-header">Total Receita</div>
          <div class="card-body">
            <div class="card-text border-bottom border-opacity-25 py-1">
              <small>Em caixa</small>
              <div :class="['float-end text-white']"><small>R$ {{
                  dadosData.em_caixa }}</small></div>
            </div>
          </div>
          <div class="card-footer text-body-white text-end">
            R$ {{ dadosData.total_receitas }}
          </div>
        </div>
      </div>

      <div class="col-sm-6" v-if="dadosData.total_despesas">
        <div class="card text-bg-danger mb-3">
          <div class="card-header">Total Despesas</div>
          <div class="card-body">
            <template v-for="(dados, ind) in dadosData.total_categorias_despesas" :key="ind">
              <div class="card-text border-bottom border-opacity-25 py-1">
                <small>{{ dados.categoria_despesa }} </small>
                <div class="float-end"><small>R$ {{ dados.valor }}</small></div>
              </div>
            </template>
          </div>
          <div class="card-footer text-body-white">
            Total
            <div class="float-end">
              R$ {{ dadosData.total_despesas }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <TabelaDatatable :dadosData="dadosData.dados" dadosAjax="" :columns="coluna"
      :ordem_tabela="[{ name: 'data_entrada', dir: 'desc' }]"
      :btnPersonalizado="{ btn: 'secondary', textoBtn: 'Ver indicações' }" @person_row="qtd_indicacao"
      :ativa_placeholder="ativa_placeholder">

    </TabelaDatatable>
  </div>
</template>

<script>
import TituloGrande from '@/components/TituloGrande.vue';
import TabelaDatatable from '@/components/TabelaDatatable.vue';
import { api } from '@/services/api'
import { AuthStore } from '@/stores/Auth';
import { toastr } from '@/plugins/toast';
import InputText from '@/components/form/InputText.vue';
import { data_hoje } from '@/assets/js/functions';
import InputSelect from '@/components/form/InputSelect.vue';

export default {
  name: 'MinhasIndicacoes',
  data() {
    return {
      auth: AuthStore(),
      dadosData: {
        dados: [],
        filtro: { periodo: '' }
      },
      coluna: [
        { data: 'detalhe', title: 'Detalhamento', width: '20%' },
        { data: 'categoria', title: 'Categoria', width: '15%' },
        { data: 'tipo', title: 'Tipo', width: '15%' },
        { data: 'valor', title: 'Valor', width: '10%' },
        { data: 'data_entrada', title: 'Data da Entrada', width: '10%' },
      ],
      dados: {
        data_ini: data_hoje(-30),
        data_fim: data_hoje(),
        tipo_relatorio: '',
      },
      dados_tipo_relatorio: [
        { valor: '', texto: 'Geral' },
        { valor: 'receita', texto: 'Receita' },
        { valor: 'despesa', texto: 'Despesa' },
      ],
      index_indicacao: null,
      ativa_placeholder: Boolean,
    }
  },
  components: {
    TituloGrande,
    TabelaDatatable,
    InputText,
    InputSelect,
  },
  computed: {
  },
  methods: {
    async carrega_relatorio() {
      this.ativa_placeholder = true
      try {
        var dadosData = await api.post('finances/report_total', this.dados, { Authorization: this.auth.token })
        if (dadosData.status == 200) {
          this.dadosData = dadosData
        }

      } catch (error) {
        toastr.erro('Erro na requisição')
      }

      this.ativa_placeholder = false
    },
  },
  mounted() {
    this.carrega_relatorio()
  },
}
</script>

<style scoped></style>